import { LegalLayout, Section } from "@/components/LegalLayout";
import { usePageMeta } from "@/utils/pageMeta";

const Legal = () => {
  usePageMeta("Mentions légales — ActiPilote", "Mentions légales du site actipilote.com : éditeur, hébergement et propriété intellectuelle.");

  return (
    <LegalLayout eyebrow="Légal" title="Mentions légales" updated="septembre 2026" testid="legal-page">
      <Section title="Éditeur du site">
        <p>Le site actipilote.com et la plateforme ActiPilote sont édités par :</p>
        <p><span className="font-semibold text-navy">FULL AGENCY</span> — EURL au capital social de 1 000,00 €<br />
        Siège social : 68 rue de la Croix de l'Orme, 78630 Morainvilliers, France<br />
        SIRET : 978 641 348 00047</p>
        <p>Directeur de la publication : le représentant légal de la société FULL AGENCY.</p>
        <p>Contact : <a href="mailto:contact@actipilote.com" className="font-semibold text-brand hover:underline">contact@actipilote.com</a></p>
      </Section>
      <Section title="Hébergement">
        <p>Le site est hébergé par :</p>
        <p><span className="font-semibold text-navy">IONOS SARL</span> — 7 place de la Gare, BP 70109, 57200 Sarreguemines Cedex, France<br />
        Site : <a href="https://www.ionos.fr" className="font-semibold text-brand hover:underline" rel="noopener noreferrer" target="_blank">www.ionos.fr</a></p>
      </Section>
      <Section title="Propriété intellectuelle">
        <p>La marque ActiPilote, son logo et l'ensemble des contenus du site (textes, visuels, éléments graphiques) sont la propriété exclusive de leur éditeur. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
      </Section>
      <Section title="Données personnelles">
        <p>Le traitement des données personnelles collectées sur ce site est décrit dans notre <a href="/privacy" className="font-semibold text-brand hover:underline">politique de confidentialité</a>.</p>
      </Section>
    </LegalLayout>
  );
};

export default Legal;
